import { MarketingTabsComponent } from './marketing-tabs.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppAnalyticsModule } from '../../directives/app-analytics.module';
import { MatTabsModule } from '@angular/material/tabs';

@NgModule({
    declarations: [MarketingTabsComponent],
    imports: [CommonModule, AppAnalyticsModule, MatTabsModule],
    exports: [MarketingTabsComponent],
})
export class MarketingTabsModule {}
